<template>
  <div class="sh_more_button">
    <el-button-group>
      <el-button v-bind="$attrs" :type="$attrs.type || 'primary'" @click="onSearch">{{ text }}</el-button>
      <el-button :type="$attrs.type || 'primary'" @click="handleMouseEnter" @mouseenter.native="handleMouseEnter">
        <i class="el-icon-arrow-down el-icon--down"></i>
      </el-button>
    </el-button-group>
    <!-- fade-slide -->
    <transition name="el-zoom-in-top">
      <div class="sh_more_button__content" v-show="showContent" :style="style">
        <slot></slot>
        <div class="sh_more_button_seacrch">
          <el-button size="mini" @click="handleMouseLeave">取消</el-button>
          <el-button type="primary" size="mini" @click="onSearch">{{ text }}</el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ShMoreButton',
  props: {
    width: {
      type: [Number, String],
      default: '300px'
    },
    text: {
      type: String,
      default: '搜索'
    }
  },
  data() {
    return {
      showContent: false
    }
  },
  computed: {
    style() {
      let widthValue = this.width
      if (typeof this.width === 'number') {
        widthValue = `${this.width}px`
      }
      return {
        width: widthValue,
        right: '0'
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    handleMouseEnter() {
      this.$nextTick(() => {
        this.showContent = true
      })
    },
    handleMouseLeave() {
      this.$nextTick(() => {
        this.showContent = false
      })
    },
    handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.showContent = false
      }
    },
    onSearch() {
      this.$emit('search')
      this.handleMouseLeave()
    }
  }
}
</script>

<style lang="scss">
$MP10: 10px;
$MP8: 8px;
.sh_more_button__content {
  position: absolute;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: $MP10;
  margin-top: $MP8;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.sh_more_button {
  position: relative;
  display: inline-block;
}

.sh_more_button_seacrch {
  margin-top: $MP8;
  display: flex;
  justify-content: flex-end;
}
</style>
